import React, {ReactNode} from 'react';
import {LightEffects} from '../lights-effect/light-effect';
import GuideCard from '../guide-card/guide-card';
import {twMerge} from 'tailwind-merge';
import LinearText from './../linear-text/linear-text';
import {Image} from '../../../../components/image/image';
interface Guide {
    title: string;
    content: ReactNode;
    titleClassName?: string;
    contentClassName?: string;
    className?: string;
}

interface GuideSectionProps {
    title?: string;
    guides: Guide[];
    contentClassName?: string;
    containerClassName?: string;
}

const GuideSection: React.FC<GuideSectionProps> = ({
    title = 'THÔNG TIN HƯỚNG DẪN',
    guides = [],
    contentClassName,
    containerClassName,
}) => {
    const containerStyle = twMerge(
        `max-w-[2000px] mx-auto pb-5 pt-5 relative w-full overflow-hidden bg-[radial-gradient(circle_at_center,_#FFD463_0%,_#F5A623_100%)]`,
        containerClassName,
    );

    const contentStyle = twMerge(
        `relative z-10 flex flex-col items-center justify-center max-w-[1200px] mx-auto md:!my-[52px]`,
        contentClassName,
        ``,
    );

    return (
        <div className={containerStyle}>
            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/10-seasons-lighting.webp"
                alt="Logo 10 Mùa Festival"
                //layout="fill"
                objectFit="contain"
                objectPosition="top"
                width={1345}
                height={906}
                className="mix-blend-screen absolute bottom-0 left-0 -translate-x-[28%] translate-y-1/3 pointer-events-none select-none "
            />

            <LightEffects />
            {/* Nội dung */}
            <div className={contentStyle}>
                <LinearText
                    as={'h3'}
                    className="!font-kpz_font
                    font-extrabold mb-[18px] w-full md:w-auto text-center
                    py-5
                    sm:py-0
                    text-[24px] 
                    md:!text-[48px] 
                    ">
                    {title}
                </LinearText>

                {/* Item đầu tiên - full width */}
                {guides.length > 0 && (
                    <div className="w-full mx-5 md:mx-0 flex justify-center mb-[16px] md:!mb-[42px]">
                        <GuideCard
                            key={guides[0].title + 0}
                            title={guides[0].title}
                            contentClassName={guides[0].contentClassName}
                            content={guides[0].content}
                            titleClassName={guides[0].titleClassName}
                            containerClassName={`${guides[0].className} h-full `}
                        />
                    </div>
                )}

                {/* Các item còn lại - grid 2 cột */}
                {guides.length > 1 && (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-[16px] md:gap-[20px] mx-5 md:mx-0 place-items-center w-full">
                        {guides.slice(1).map((item, index) => (
                            <GuideCard
                                key={item.title + (index + 1)}
                                title={item.title}
                                contentClassName={item.contentClassName}
                                content={item.content}
                                titleClassName={item.titleClassName}
                                containerClassName={`${item.className} h-full`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GuideSection;
